import { render, staticRenderFns } from "./user-fields.vue?vue&type=template&id=6833ee04&scoped=true"
import script from "./user-fields.vue?vue&type=script&lang=ts"
export * from "./user-fields.vue?vue&type=script&lang=ts"
import style0 from "./user-fields.vue?vue&type=style&index=0&id=6833ee04&prod&lang=css"
import style1 from "./user-fields.vue?vue&type=style&index=1&id=6833ee04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833ee04",
  null
  
)

export default component.exports